import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { useAuth } from '../../../context/Auth';
import { PlateTableFilters } from './RegisteredPlateTable';
import PlateGroupsDropdown from '../../../components/dashboard/PlateGroupsDropdown';
import PlateStatusDropdown from '../../../components/dashboard/PlateStatusDropdown';

interface Props {
    filters: PlateTableFilters;
    setFilters: React.Dispatch<React.SetStateAction<PlateTableFilters>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

export default function RegisteredPlateFilter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { user: authenticatedUser } = useAuth();

    const [status, setStatus] = useState<'active' | 'inactive' | 'all'>('all');
    const [groupsIds, setGroupsIds] = useState<number[]>([]);

    const handleCleanFilter = () => {
        setTextFilter('');
        setGroupsIds([]);
        setStatus('all');
    };

    const handleFilter = () => {
        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            groupsIds: groupsIds.length ? groupsIds : undefined,
            isActive: status === 'active' ? true : status === 'inactive' ? false : undefined
        });
    };


    if (!authenticatedUser) {
        return <></>;
    }

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            <PlateGroupsDropdown
                value={groupsIds}
                setValue={setGroupsIds}
                zIndex={2}
            />

            <PlateStatusDropdown
                value={status}
                setValue={setStatus}
                zIndex={1}
            />
        </Filters>
    );
}
